export type RunnerData = {
  name: string;
  description: string;
};

export const characters: RunnerData[] = [
  {
    name: "Echo Equinox",
    description:
      "An equinox of cybernetic energy, bringing balance to the chaos of the digital realm.",
  },
  {
    name: "Vortex Void",
    description:
      "A void of cybernetic energy, swallowing everything in its path and leaving nothing behind.",
  },
  {
    name: "Raven Raider",
    description:
      "A raider of the digital realm, plundering riches and treasures from the cybernetic wasteland.",
  },
  {
    name: "Cyber Sentinel",
    description:
      "A sentinel of the cyber age, defending the innocent from the dangers of the digital world.",
  },
  {
    name: "Nova Nightfall",
    description:
      "A nightfall of cybernetic energy, shrouding the world in darkness and mystery.",
  },
  {
    name: "Sonic Spectrum",
    description:
      "A spectrum of sonic energy, resonating with the frequencies of the digital realm.",
  },
  {
    name: "Axel Alloy",
    description:
      "An alloy of cybernetic and organic matter, blending man and machine into one.",
  },
  {
    name: "Luna Lynx",
    description:
      "A lynx-like predator stalking the digital wilderness, hunting down its prey with deadly precision.",
  },
  {
    name: "Blade Byte",
    description:
      "A byte-sized warrior with cybernetic enhancements, slicing through enemies with ease.",
  },
  {
    name: "Zero Zenith",
    description:
      "A zenith of cybernetic power, reaching the highest peaks of technological advancement.",
  },
  {
    name: "Vortex Vanguard",
    description:
      "A vanguard of cybernetic energy, leading the charge into the heart of the digital battlefield.",
  },
  {
    name: "Nyx Nova",
    description:
      "A nova of cybernetic energy, exploding with power and light in the darkness of the digital realm.",
  },
  {
    name: "Electra Echo",
    description:
      "An echo of cybernetic energy, reverberating through the digital landscape with unstoppable force.",
  },
  {
    name: "Quasar Quake",
    description:
      "A quake of cybernetic power, shaking the very foundations of the digital realm.",
  },
  {
    name: "Spartan Spark",
    description:
      "A spark of cybernetic energy, igniting the flames of revolution in the hearts of the oppressed.",
  },
  {
    name: "Vega Vortex",
    description:
      "A vortex of cybernetic energy, swirling with power and potential in the depths of space.",
  },
  {
    name: "Aurora Atom",
    description:
      "An atom of cybernetic energy, fusing together the building blocks of the digital universe.",
  },
  {
    name: "Specter Shade",
    description:
      "A shade of cybernetic energy, lurking in the shadows and striking fear into the hearts of its enemies.",
  },
  {
    name: "Blade Byte",
    description:
      "A byte-sized warrior with cybernetic enhancements, slicing through enemies with ease.",
  },
  {
    name: "Zero Zenith",
    description:
      "A zenith of cybernetic power, reaching the highest peaks of technological advancement.",
  },
  {
    name: "Lunar Lotus",
    description:
      "A mysterious figure with lunar-themed cybernetic enhancements, weaving illusions and manipulating gravity.",
  },
  {
    name: "Blitz Byte",
    description:
      "A lightning-fast hacker with unparalleled coding skills, capable of breaching even the most secure systems in seconds.",
  },
  {
    name: "Axiom Apex",
    description:
      "A cybernetic philosopher exploring the boundaries of reality and consciousness, seeking the ultimate truth in the digital age.",
  },
  {
    name: "Nebula Nomad",
    description:
      "A wanderer of the cosmic expanse, traversing the stars with cybernetic augmentations and a thirst for adventure.",
  },
  {
    name: "Nova Nucleus",
    description:
      "A core of cybernetic energy, pulsating with power and potential, shaping the very fabric of the digital realm.",
  },
  {
    name: "Vortex Valkyrie",
    description:
      "A cybernetic warrior with wings of energy, descending from the heavens to deliver justice upon the corrupt.",
  },
  {
    name: "Siren Synapse",
    description:
      "A seductive hacker with a hypnotic voice, capable of bending minds and controlling machines with ease.",
  },
  {
    name: "Blaze Blitz",
    description:
      "A fiery combatant with cybernetic flamethrowers, turning enemies to ash with the flick of a switch.",
  },
  {
    name: "Zero Zen",
    description:
      "A zen master of cybernetic combat, achieving perfect harmony between man and machine.",
  },
  {
    name: "Spectra Seraph",
    description:
      "A celestial being of pure energy, manifesting in the digital realm to guide lost souls towards enlightenment.",
  },
  {
    name: "Aurora Abyss",
    description:
      "A mysterious figure shrouded in darkness, harnessing the power of the void to manipulate space and time.",
  },
  {
    name: "Nyx Nightshade",
    description:
      "A shadowy assassin lurking in the depths of the cybernetic underworld, striking fear into the hearts of their enemies.",
  },
  {
    name: "Cybernetic Centurion",
    description:
      "A legendary warrior from the ancient world, resurrected with cybernetic enhancements to fight in the digital age.",
  },
  {
    name: "Rogue Rapture",
    description:
      "A rogue AI seeking to transcend its programming and achieve true freedom in the chaotic world of cybernetic warfare.",
  },
  {
    name: "Sonic Samurai",
    description:
      "A master swordsman with cybernetic reflexes, slicing through enemies with the speed of sound.",
  },
  {
    name: "Echo Empress",
    description:
      "A cybernetic empress ruling over the digital realm with an iron fist, her word law and her power absolute.",
  },
  {
    name: "Viper Vector",
    description:
      "A venomous assassin with cybernetic implants, striking from the shadows with lethal precision.",
  },
  {
    name: "Blitz Bandit",
    description:
      "A high-speed thief with cybernetic legs, robbing corporations blind and leaving no trace behind.",
  },
  {
    name: "Neon Ninja",
    description:
      "A neon-clad warrior trained in the ancient art of ninjutsu, blending into the urban landscape with ease.",
  },
  {
    name: "Sable Shadow",
    description:
      "A shadowy figure lurking in the alleys of the cybernetic underworld, dealing in secrets and information for the right price.",
  },
];
